<h2 class="text-2xl font-bold">Address information</h2>
<button *ngIf="environment.mockSignup" type="button" (click)="fillMockAddress()" class="mt-4 px-4 py-2 bg-gray-700 text-white text-sm font-medium rounded-md 
         hover:bg-gray-800 active:bg-gray-900 transition">
    Fill with Mock Data
</button>
<form *ngIf="form" [formGroup]="form" class="w-full pt-6 space-y-5">
    <div>
        <label class="block text-sm font-medium mb-1"> {{ textService.getText('form_label_first_name') }} </label>
        <input type="text" formControlName="firstName"
            class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
        <div *ngIf="form.get('firstName')?.touched && form.get('firstName')?.errors?.['required']"
            class="text-sm text-red-600 mt-1"> {{ textService.getText('form_validate_first_name') }}
            <!-- First name is required. -->
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium mb-1"> {{ textService.getText('form_label_last_name') }} </label>
        <input type="text" formControlName="lastName"
            class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
        <div *ngIf="form.get('lastName')?.touched && form.get('lastName')?.errors?.['required']"
            class="text-sm text-red-600 mt-1"> {{ textService.getText('form_validate_last_name') }}
            <!-- Last name is required. -->
        </div>
    </div>
    <!-- Country -->
    <div>
        <label class="block text-sm font-medium text-gray-700 mb-1"> {{ textService.getText('form_label_country') }}
        </label>
        <select id="country" formControlName="country"
            class="w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring focus:ring-blue-500">
            <option value="">-- Select --</option>
            <option *ngFor="let country of country" [value]="country.value">
                {{ country.label }}
            </option>
        </select>
        <div *ngIf="form.get('country')?.touched && form.get('country')?.invalid" class="text-red-500 text-xs mt-1"> {{
            textService.getText('form_validate_country') }}
        </div>
    </div>
    <!-- Business -->
    <div>
        <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_company') }} </label>
        <input type="text" formControlName="business"
            class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
    </div>

    <!-- Street -->
    <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ textService.getText('form_label_street') }}
        </label>
        <input type="text" formControlName="street"
            class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2" />
        <div *ngIf="form.get('street')?.touched && form.get('street')?.invalid" class="text-red-500 text-xs mt-1"> {{
            textService.getText('form_validate_street_format') }}
            <!-- Address is required -->
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ textService.getText('form_label_city') }}
        </label>
        <input type="text" formControlName="city"
            class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2" />
        <div *ngIf="form.get('city')?.touched && form.get('city')?.invalid" class="text-red-500 text-xs mt-1"> {{
            textService.getText('form_validate_city_format') }}
            <!-- City is required -->
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700 mb-1"> {{ textService.getText('form_label_state')
            }}</label>
        <select id="state" formControlName="state"
            class="w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed">
            <option value="">-- Select --</option>
            <option *ngFor="let state of states" [value]="state.value">
                {{ state.label }}
            </option>
        </select>
        <div *ngIf="form.get('state')?.touched && form.get('state')?.invalid" class="text-red-500 text-xs mt-1">{{
            textService.getText('form_validate_state') }}
            <!-- State is required -->
        </div>
    </div>

    <div *ngIf="selectedCountry?.hasZipCode !== false">
        <label class="block text-sm font-medium text-gray-700 mb-1" for="postalCode">{{
            textService.getText('form_label_postal_code') }}</label>
        <input id="postalCode" type="text" formControlName="postalCode"
            class="w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2" />
        <div *ngIf="form.get('postalCode')?.touched && form.get('postalCode')?.invalid"
            class="text-red-500 text-xs mt-1">{{ textService.getText('form_validate_postal_code') }}
            <!-- Zip / Postal Code is required -->
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_phone') }}</label>

        <!-- Nuevo componente de teléfono -->
        <app-phone-number-field formControlName="phone"></app-phone-number-field>

        <!-- <div class="flex w-full"> -->
            <!-- Selector de país -->
            <!-- <div class="relative w-auto flex-shrink-0">
                <button type="button" (click)="toggleDropdown()"
                    class="h-full flex items-center gap-1 border rounded-l-md px-2 bg-gray-50 hover:bg-gray-100 text-md">
                    {{ selectedCountries.flag }}
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </button> -->

                <!-- Dropdown -->
                <!-- <div *ngIf="open"
                    class="absolute left-0 z-10 mt-1 w-56 bg-white border rounded-md shadow-lg max-h-60 overflow-y-auto"> -->
                    <!-- buscador -->
                    <!-- <input type="text" [value]="search" (input)="onSearch($event)"
                        class="w-full px-2 py-1 border-b text-sm" placeholder="Search country..." />

                    <div *ngFor="let c of filteredCountries" (click)="selectCountry(c)" [id]="'country-' + c.code"
                        class="px-2 py-1 hover:bg-gray-100 cursor-pointer text-sm">
                        {{ c.flag }} {{ c.name }} ({{ c.dial }})
                    </div>
                </div>
            </div> -->

            <!-- Teléfono -->
            <!-- <input type="tel" formControlName="phone"
                class="flex-1 min-w-0 border border-l-0 rounded-r-md px-3 py-2 focus:ring focus:ring-blue-300"
                placeholder="(201) 559-4773" />
        </div> -->

        <!-- Errores -->
        <!-- <div *ngIf="form.get('phone')?.touched && form.get('phone')?.errors" class="text-sm text-red-600 mt-1">
            <div *ngIf="form.get('phone')?.errors?.['required']">Phone number is required.</div>
            <div *ngIf="form.get('phone')?.errors?.['pattern']">Enter a valid phone number.</div>
        </div> -->

    </div>


    <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Currency</label>
        <select formControlName="currency"
            class="w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring focus:ring-blue-500">
            <option value="" disabled>-- Select --</option>
            <option value="USD">USD</option>
            <option value="GBP">GBP</option>
            <option value="EUR">EUR</option>
            <option value="AUD">AUD</option>
        </select>

        <!-- Validation message -->
        <div *ngIf="form.get('currency')?.touched && form.get('currency')?.invalid" class="text-red-500 text-xs mt-1">
            Currency is required.
        </div>
    </div>

    <re-captcha
      #captchaRef
      size="invisible"
      badge="bottomleft"
      errorMode="handled"
      (resolved)="onCaptchaResolved($event)">
    </re-captcha>
</form>